module.exports = __webpack_public_path__ + "static/media/plus-icon.6c82e3eb.svg";